import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';
import { findIndex as _findIndex } from 'lodash';

import { resetClientTimeline, fetchClientTimeline } from 'actions/ClientsActions';
import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import IntlDateRelative from 'components/layout/IntlDateRelative';

import TimelineEvent from 'components/layout/client/TimelineEvent';

class Timeline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      resPerPage: 10,
      filter: 'all',
    };
  }

  componentWillMount = () => {
    const { resetData } = this.props;
    resetData();
    this.loadData();
  };

  setFilter = (e, filter) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ filter });
  };

  loadMore = () => {
    this.setState(
      prevState => ({ page: prevState.page + 1 }),
      () => {
        this.loadData();
      }
    );
  };

  loadData = () => {
    const { fetchData, clientId } = this.props;
    const { page, resPerPage } = this.state;

    fetchData(clientId, page, resPerPage);
  };

  render() {
    const {
      intl: { messages },
      clientTimeline,
      user,
    } = this.props;
    const { filter } = this.state;

    const pending = clientTimeline.isLoading;
    const momentWeekAgo = moment()
      .subtract(7, 'days')
      .startOf('day');

    const eventList = [];
    clientTimeline.events.events.map(event => {
      const eventDate = moment(event.cdate).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={event.cdate} />
      ) : (
        <IntlDate date={event.cdate} />
      );

      switch (filter) {
        case 'type_notes':
          if (event.type === 'NOTE_SAVED') {
            eventList.push(<TimelineEvent date={eventDate} event={event} key={event.id} />);
          }
          break;

        case 'type_own_notes':
          if (
            event.type === 'NOTE_SAVED' &&
            _findIndex(event.dyn_params, { name: 'creatorId', value: user.username }) > -1
          ) {
            eventList.push(<TimelineEvent date={eventDate} event={event} key={event.id} />);
          }
          break;

        default:
          eventList.push(<TimelineEvent date={eventDate} event={event} key={event.id} />);
          break;
      }
    });

    let loadMore;
    if (!pending && clientTimeline.events.events.length < clientTimeline.events.count) {
      loadMore = (
        <Row>
          <Col xs={12}>
            <div class="text-center">
              <Button onClick={this.loadMore}>{messages.load_more}</Button>
            </div>
          </Col>
        </Row>
      );
    } else if (pending) {
      loadMore = <Loader />;
    }

    return (
      <div class="bg-master-lighter">
        <div class="bg-filter-menu v-align-middle filters clearfix">
          <div class="pull-left padding-15 p-l-25 p-r-25 m-r-30 text-uppercase bold bg-filter-title filter-title">
            {messages.filter}
          </div>{' '}
          <ul class="filter-menu no-margin">
            <li class={filter === 'all' ? 'active ' : ''}>
              <a href="#all" class="text-uppercase" onClick={e => this.setFilter(e, 'all')}>
                {messages.all}
              </a>
            </li>
            <li class={filter === 'type_notes' ? 'active ' : ''}>
              <a href="#notes" class="text-uppercase" onClick={e => this.setFilter(e, 'type_notes')}>
                {messages.show_notes}
              </a>
            </li>
            <li class={filter === 'type_own_notes' ? 'active ' : ''}>
              <a href="#myNotes" class="text-uppercase" onClick={e => this.setFilter(e, 'type_own_notes')}>
                {messages.show_my_notes}
              </a>
            </li>
          </ul>
        </div>
        <div class="timeline-container top-circle p-b-30">
          <section class="timeline">{eventList}</section>

          {loadMore}
        </div>
      </div>
    );
  }
}
Timeline.defaultProps = {
  timezone: 'UTC',
};

const mapStateToProps = state => {
  return {
    clientTimeline: state.clientTimeline,
    user: state.login.user,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    resetData: () => {
      dispatch(resetClientTimeline());
    },
    fetchData: (clientId, page, resPerPage) => {
      dispatch(fetchClientTimeline(clientId, (page - 1) * resPerPage, resPerPage));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Timeline)
);
